var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconClockCountdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18_2105)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.1665 19.125C31.5942 26.055 25.7442 31.5 18.6665 31.5C15.0861 31.5 11.6523 30.0777 9.12056 27.5459C6.58882 25.0142 5.1665 21.5804 5.1665 18C5.1665 10.9223 10.6115 5.07234 17.5415 4.5",
    stroke: "#3661EB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6665 10.125V18H26.5415",
    stroke: "#3661EB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1665 6.75C24.0985 6.75 24.854 5.99448 24.854 5.0625C24.854 4.13052 24.0985 3.375 23.1665 3.375C22.2345 3.375 21.479 4.13052 21.479 5.0625C21.479 5.99448 22.2345 6.75 23.1665 6.75Z",
    fill: "#3661EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.229 10.125C29.161 10.125 29.9165 9.36948 29.9165 8.4375C29.9165 7.50552 29.161 6.75 28.229 6.75C27.297 6.75 26.5415 7.50552 26.5415 8.4375C26.5415 9.36948 27.297 10.125 28.229 10.125Z",
    fill: "#3661EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.604 15.1875C32.536 15.1875 33.2915 14.432 33.2915 13.5C33.2915 12.568 32.536 11.8125 31.604 11.8125C30.672 11.8125 29.9165 12.568 29.9165 13.5C29.9165 14.432 30.672 15.1875 31.604 15.1875Z",
    fill: "#3661EB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18_2105"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    transform: "translate(0.666504)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClockCountdown);
export default __webpack_public_path__ + "static/media/icon-ClockCountdown.d7dcfbf5846eb0362565422523bd1b95.svg";
export { ForwardRef as ReactComponent };